// This fixes a bug where the map slides off too far to the right when the left panel slides in
export const MAP_RESIZE_INTERVAL = 10;
export const MAP_RESIZE_DURATION = 500;

export const mapResize = () => {
    const update = setInterval(() => window.dispatchEvent(new Event('resize')), MAP_RESIZE_INTERVAL);
    setTimeout(() => clearInterval(update), MAP_RESIZE_DURATION); // Increased to be more than mapmenu.module.scss transition time, otherwise box does not remain centered
};
